import React from 'react';
import { withProps } from 'recompose';
import { InfoWindowV2 } from 'components/core/GoogleMap';
import FacilityCard from 'components/organisms/FacilityCard';

export const enhance = withProps(
	({
		actions,
		facility,
		baseUrl,
		facilitySelected,
		handleFacilityCardVisible,
		handleFacilitySelected,
		handleFacilityDeselected,
		handlePinDeselected,
		location,
		searchType,
		searchParams,
		cloudfrontUrl,
		inMapView,
	}) => ({
		location: facility.location,
		content: (
			<FacilityCard
				facility={facility}
				baseUrl={baseUrl}
				cloudfrontUrl={cloudfrontUrl}
				facilitySelected={facilitySelected}
				getFacilityCardPhoneNumber={() =>
					actions.getFacilityCardPhoneNumber(
						location.city,
						location.state,
						facility.id,
					)
				}
				handleFacilitySelected={handleFacilitySelected}
				handleFacilityDeselected={handleFacilityDeselected}
				handlePinDeselected={handlePinDeselected}
				miniCard
				lazyLoad={false}
				onVisible={handleFacilityCardVisible}
				storageType={searchType}
				searchParams={searchParams}
				inMapView={inMapView}
				hasOMI={facility.hasOnlineMoveins}
			/>
		),
	}),
);

export default enhance(InfoWindowV2);
